import { defineStore } from 'pinia';
import { SET_COUNT, INCREASE_COUNT } from '#shared/types/actions';
import { GET_FORMATTED_COUNT, GET_IS_MORE_THAN_ONE, GET_IS_EMPTY } from '#shared/types/getters';
import { MAX_BAG_COUNT } from '#shared/constants';

export const useNavQuickBag = defineStore('navQuickBag', {
  state: () => ({
    count: 0,
  }),
  getters: {
    [GET_FORMATTED_COUNT]: (state) => (state.count > MAX_BAG_COUNT ? MAX_BAG_COUNT : String(state.count)),
    [GET_IS_MORE_THAN_ONE]: (state) => state.count > 1,
    [GET_IS_EMPTY]: (state) => state.count === 0,
  },
  actions: {
    [SET_COUNT](count) {
      if (typeof count !== 'number') {
        throw new Error('Count must be a number');
      }

      this.count = count < 0 ? 0 : count;
    },

    [INCREASE_COUNT](count) {
      if (typeof count !== 'number') {
        throw new Error('Count must be a number');
      }

      this.count += count;
    },
  },
});
